import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Endpoints} from '../../shared/config/endpoints';
import {Store} from '@ngrx/store';
import {AppState} from '../../store/app.state';
import {BehaviorSubject, Observable, Subject, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InstagramService {
  private orgId: number;
  private userId: number;
  private userName: string;
  private userRole: string;
  department: any;
  private baseUri = this.endpoints.instagramServiceUrl;
  postToView = new BehaviorSubject<any>({});
  postModalReady$ = new Subject<void>();

  constructor(
    private http: HttpClient,
    private endpoints: Endpoints,
    store: Store<AppState>
  ) {
    store.select('userInfo').subscribe((info) => {
      if (info && info.organization) {
        this.orgId = info.organization.id;
      }
      if (info && info.user) {
        this.userId = info.user.id;
        this.userName = `${info.user.firstName || ''} ${info.user.lastName || ''}`.trim();
      }
      this.userRole = info && info.roleName === 'Super Admin'
        ? 'ADMIN'
        : info && info.supervisor
          ? 'SUPERVISOR'
          : 'AGENT';
    });
    this.department = JSON.parse(localStorage.getItem('departmentInfo'));
  }

  instagramDetails(): Observable<any> {
    return this.http.get(`${this.baseUri}/pages/${this.orgId}/details`);
  }

  instagramPageInsights(): Observable<any> {
    return this.http.get(`${this.baseUri}/pages/${this.orgId}/insights`);
  }

  fetchPosts(pageId: number,  page: number, population: number): Observable<any> {
    return this.http.get(`${this.baseUri}/pages/media?orgId=${this.orgId}&pageId=${pageId}&page=${page}&population=${population}`);
  }

  fetchComments(mediaId: string) {
    return this.http.get(`${this.baseUri}/pages/${this.orgId}/comments/${mediaId}`);
  }

  fetchPost(postId: string) {
    return this.http.get(`${this.baseUri}/pages/${this.orgId}/media/${postId}`);
  }

  postComment(comment: string, mediaId: string) {
    return this.http.post(`${this.baseUri}/pages/${this.orgId}/comments/${mediaId}`, {comment});
  }

  replyComment(commentId: string, message: string): Observable<any> {
    return this.http.post(`${this.baseUri}/pages/${this.orgId}/comment/${commentId}/replies`, {
      message,
      reply_by_id: this.userId,
      reply_by_name: this.userName,
      reply_by_role: this.userRole,
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  deleteComment(commentId: string) {
    return this.http.delete(`${this.baseUri}/pages/${this.orgId}/comments/${commentId}`);
  }

  deleteReplyResponse(commentId: string) {
    return this.http.post(`${this.baseUri}/pages/${this.orgId}/comment/${commentId}/unsend-reply`, {
      deleted_by: this.userName,
      deleted_by_role: this.userRole,
      deleted_by_id: this.userId,
    });
  }
}
